import { render, staticRenderFns } from "./SalemanSetting.vue?vue&type=template&id=28dcadbf&scoped=true&"
import script from "./SalemanSetting.vue?vue&type=script&lang=js&"
export * from "./SalemanSetting.vue?vue&type=script&lang=js&"
import style0 from "./SalemanSetting.vue?vue&type=style&index=0&id=28dcadbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dcadbf",
  null
  
)

export default component.exports